import React from 'react';
import { StreamingTextProps } from './types';

export const StreamingText: React.FC<StreamingTextProps> = ({ content }) => {
  return (
    <div className="streaming-text">
      <div className="streaming-content">{content}</div>
      <span className="streaming-cursor" />
    </div>
  );
};

export default StreamingText;
